const handleResponse = async (callback) => {
    const response = await callback()
        .then(async resp => {
            return resp.text()
                .then(async data => {
                   if(data.length > 0){
                       return {
                           ok: resp.ok,
                           data: JSON.parse(data)
                       };
                   }else{
                       return {
                           ok: resp.ok,
                           data: {}
                       }
                   }
                })
                .catch(async error => {
                    console.error("Error service call: ",error)
                    return {
                        ok: false,
                        status: resp.status,
                        error: error
                    };
                });
        });

    return response;

}


export {
    handleResponse,
}